import React from "react";
import Header from "../header";
import Sidebar from "../sidebar";
import "./defaultLayout.scss";

export default function DefaultLayout({ children }) {
  return (
    <div className="app-layout">
      <Header />
      <div className="app-body">
        <Sidebar />
        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
}
